import { Text } from "@mantine/core";
import type { TextProps } from "@mantine/core";

interface NoDataMessageProps extends TextProps {
  message?: string;
}

function NoDataMessage({ message, ...textProps }: NoDataMessageProps) {
  return (
    <Text p="xl" ta="center" {...textProps}>
      {message || "Keine Daten vorhanden"}
    </Text>
  );
}

export { NoDataMessage };
